import CarrierStatusApi from "./carrier-status-api.component";

export default CarrierStatusApi;
